import { DEFAULT_VIEW_ID, DEFAULT_VIEW_STYLE } from '../defaults';
import { View } from '../types/View';
import { ViewProperty } from '../types/ViewProperty';

const defaultProperties: ViewProperty[] = [
    {
        fieldId: 1,
        orderNum: 0,
    },
    {
        fieldId: 2,
        orderNum: 1,
    },
    {
        fieldId: 9,
        orderNum: 2,
    },
];

export const defaultView: View = {
    clientId: null,
    userName: '',
    viewId: DEFAULT_VIEW_ID,
    name: 'Default view',
    style: DEFAULT_VIEW_STYLE,
    properties: defaultProperties,
};
